import { forwardRef, useRef } from 'react'
import { noop } from 'utils'
import classNames from 'classnames'
import { nanoid } from '@reduxjs/toolkit'
import PropTypes from 'prop-types'

const TableCheckBox = forwardRef(
  (
    {
      id,
      className = 'check_inp',
      name = '',
      value = '',
      checked,
      disabled = false,
      onChange = noop,
      onCheckedChange = noop,
    },
    ref
  ) => {
    const idRef = useRef(id || nanoid())
    const handleChange = event => {
      onChange(event)
      onCheckedChange(event.target.checked)
    }

    return (
      <label
        className={classNames(className, {
          on: checked,
          in_active: disabled,
        })}>
        <input
          type="checkbox"
          name={name}
          value={value}
          id={idRef.current}
          className="inp_check"
          checked={checked}
          onChange={handleChange}
          ref={ref}
        />
        <span className="img_comm ico_check" />
      </label>
    )
  }
)

export default TableCheckBox
TableCheckBox.displayName = 'TableCheckBox'

TableCheckBox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onCheckedChange: PropTypes.func,
}
